import { CategoryPill, type CategoryPillItem } from '../../../modules/design-system';
import { useScrollRow } from '../shared/useScrollRow';

type Props = {
  categories: CategoryPillItem[];
  activeId?: string;
  onSelect?: (id: string) => void;
};

/**
 * The desktop category pills (repackz-handoff §8.1): a row that scrolls by
 * the wheel and a mouse drag and fades at the edges it can still scroll
 * past. A hair of padding keeps the end pills' rims from being clipped.
 */
export function CategoryPillRow({ categories, activeId, onSelect }: Props) {
  const rowRef = useScrollRow<HTMLDivElement>(categories.length);

  return (
    <nav aria-label="Sport categories" className="min-w-0">
      <div ref={rowRef} className="scrollbar-hide flex items-center gap-2 overflow-x-auto px-[2px] py-1">
        {categories.map((category) => (
          <CategoryPill
            key={category.id}
            label={category.label}
            iconSrc={category.iconSrc}
            active={category.id === activeId}
            {...(onSelect ? { onClick: () => onSelect(category.id) } : {})}
            className="shrink-0"
          />
        ))}
      </div>
    </nav>
  );
}
